var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: _vm.galleryID } },
    _vm._l(_vm.images, function(image, key) {
      return _c(
        "a",
        {
          key: key,
          attrs: {
            href: image.largeURL,
            "data-pswp-width": image.width,
            "data-pswp-height": image.height,
            target: "_blank",
            rel: "noreferrer"
          }
        },
        [_c("img", { attrs: { src: image.thumbnailURL, alt: "" } })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }